import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
// import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
// import RequirePermissions from "@saleor/components/RequirePermissions";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import useUser from "@saleor/hooks/useUser";
import { UserPermissionProps } from "@saleor/types";
import { SmopUserTypeCode } from "@saleor/types/globalTypes";
// import { PermissionEnum } from "@saleor/types/globalTypes";
import React from "react";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles(
  theme => ({
    arrowIcon: {
      width: theme.spacing(4)
    },
    tableRow: {
      cursor: "pointer"
    }
  }),
  { name: "HomeNotificationTable" }
);

interface HomeNotificationTableProps extends UserPermissionProps {
  motherOrders: number;
  storeOrders: number;
  // productsOutOfStock: number;
  onMotherOrdersClick: () => void;
  onStoreOrdersClick: () => void;
  // onProductsOutOfStockClick: () => void;
}

const HomeNotificationTable: React.FC<HomeNotificationTableProps> = props => {
  const {
    onMotherOrdersClick,
    onStoreOrdersClick,
    // onProductsOutOfStockClick,
    motherOrders,
    storeOrders
    // productsOutOfStock,
    // userPermissions
  } = props;

  const classes = useStyles(props);
  const { user } = useUser();

  return (
    <Card>
      <ResponsiveTable>
        <TableBody className={classes.tableRow}>
          {/* <RequirePermissions
            userPermissions={userPermissions}
            requiredPermissions={[PermissionEnum.MANAGE_ORDERS]}
          > */}
          {(user.userType.code === SmopUserTypeCode.OMI_ADMIN ||
            user.userType.code === SmopUserTypeCode.OMI_OPS) && (
            <TableRow hover={true} onClick={onMotherOrdersClick}>
              <TableCell>
                {motherOrders === undefined ? (
                  <Skeleton />
                ) : motherOrders === 0 ? (
                  <Typography>
                    <FormattedMessage
                      defaultMessage="-  Mother Orders are Ready"
                      id="homeNotificationTableNoOrders"
                    />
                  </Typography>
                ) : (
                  <Typography>
                    <FormattedMessage
                      defaultMessage="{amount}  Mother Orders are Ready"
                      id="homeNotificationTableOrders"
                      values={{
                        amount: <strong>{motherOrders}</strong>
                      }}
                    />
                  </Typography>
                )}
              </TableCell>
              {/* <TableCell className={classes.arrowIcon}>
                  <KeyboardArrowRight />
                </TableCell> */}
            </TableRow>
          )}
          {(user.userType.code === SmopUserTypeCode.STORE_ADMIN ||
            user.userType.code === SmopUserTypeCode.SELLER_MASTER ||
            user.userType.code === SmopUserTypeCode.OMI_OPS) && (
            <TableRow hover={true} onClick={onStoreOrdersClick}>
              <TableCell>
                {storeOrders === undefined ? (
                  <Skeleton />
                ) : storeOrders === 0 ? (
                  <Typography>
                    <FormattedMessage
                      defaultMessage="-  New Store Orders"
                      id="homeNotificationsNoPayments"
                    />
                  </Typography>
                ) : (
                  <Typography>
                    <FormattedMessage
                      defaultMessage="{amount}  New Store Orders"
                      id="homeNotificationTablePayments"
                      values={{
                        amount: <strong>{storeOrders}</strong>
                      }}
                    />
                  </Typography>
                )}
              </TableCell>
              {/* <TableCell className={classes.arrowIcon}>
                  <KeyboardArrowRight />
                </TableCell> */}
            </TableRow>
          )}
          {/* </RequirePermissions> */}
          {/* <RequirePermissions
            userPermissions={userPermissions}
            requiredPermissions={[PermissionEnum.MANAGE_PRODUCTS]}
          >
            <TableRow hover={true} onClick={onProductsOutOfStockClick}>
              <TableCell>
                {productsOutOfStock === undefined ? (
                  <Skeleton />
                ) : productsOutOfStock === 0 ? (
                  <Typography>
                    <FormattedMessage
                      defaultMessage="No products out of stock"
                      id="homeNotificationsTableNoProducts"
                    />
                  </Typography>
                ) : (
                  <Typography>
                    <FormattedMessage
                      defaultMessage="{amount, plural,one {One product out of stock}other {{amount} Products out of stock}}"
                      id="homeNotificationTableProducts"
                      values={{
                        amount: <strong>{productsOutOfStock}</strong>
                      }}
                    />
                  </Typography>
                )}
              </TableCell>
              <TableCell className={classes.arrowIcon}>
                <KeyboardArrowRight />
              </TableCell>
            </TableRow>
          </RequirePermissions> */}
        </TableBody>
      </ResponsiveTable>
    </Card>
  );
};
HomeNotificationTable.displayName = "HomeNotificationTable";
export default HomeNotificationTable;
